import axios from "axios";
import { Cookies } from "react-cookie";

const IR_ARCHIVES = "/ir-archives";
const IR_ANNOUNCEMENT = "/announcement";
const POPUP = "popup";
const STOCK_INFO = "stock-info";

export const setInitAxioSetting = () => {
  axios.defaults.baseURL = process.env.REACT_APP_API_DOMAIN;
  const cookie = new Cookies();
  const accessToken = cookie.get("access_token");

  if (accessToken !== undefined) {
    axios.defaults.headers.common.Authorization = `Bearer ${accessToken}`;
  }
  interceptor();
};

export const interceptor = () => {
  axios.interceptors.request.use((config) => {
    const cookie = new Cookies();
    const accessToken = cookie.get("access_token");

    if (accessToken !== undefined) {
      axios.defaults.headers.common.Authorization = `Bearer ${accessToken}`;
    }

    config.withCredentials = !config.url?.includes(
      "https://api.odcloud.kr/api/nts-businessman"
    );
    return config;
  });

  axios.interceptors.response.use(
    (response) => {
      return response;
    },
    async (error) => {
      // 응답 바디는 { data: { statusCode } } 로 감싸진 경우와 평문인 경우가 섞여 있다
      const payload = error.response?.data;
      const body = payload?.data ?? payload;
      const status = body?.statusCode ?? error.response?.status;

      if (status === 401) {
        const cookie = new Cookies();
        const sessing = cookie.get("sessing");
        if (sessing && body?.message === "Unauthorized") {
          alert("세션이 만료 되었습니다. 다시 로그인 해주시기 바랍니다.");
          Logout();
        }
      } else {
        console.error(
          `[api] ${error.config?.method?.toUpperCase()} ${
            error.config?.url
          } → ${status ?? error.message}`,
          body ?? error
        );
      }
      return Promise.reject(error);
    }
  );
};

const setCookie = (key: string, value: string) => {
  const secure = window.location.protocol === "https:" ? " Secure;" : "";
  document.cookie = `${key}=${value}; path=/; SameSite=Strict;${secure}`;
};

const delCookie = (key: string) => {
  document.cookie = `${key}=; path=/; max-age=0;`;
};

export const Logout = () => {
  try {
    delCookie("sessing");
    delCookie("access_token");
    window.location.replace("/");
  } catch (error) {
    console.log(error);
  }
};

export const checkingToken = async () => {
  try {
    const cookie = new Cookies();

    const accessToken = cookie.get("access_token");

    if (!accessToken || accessToken.length === 0) {
      alert("잘못된 접근입니다.");
      Logout();
    } else {
      const result = await axios.get(checkToken());
      return result;
    }
  } catch (error) {
    console.log(error);
  }
};

// legacy (axios baseURL 사용)
const PRODUCT = "/product";
const RELATED_PF = "/relatedPF";
const HOT_PFS = "/hotPFs";
const LATEST_COL = "/latestcolumn";
const COLUMNS = "/columns";

export const getProduct = (): string => PRODUCT;
export const getRelatedPF = (): string => RELATED_PF;
export const getHotPFs = (): string => HOT_PFS;
export const getLatestCol = (): string => LATEST_COL;
export const getColumns = (): string => COLUMNS;

// admin
const USER = "/user";
const PORTFOLIO = "/portfolio";
const COMMON = "/common";
const EVENT = "/event";
const BLUE_LETTER = "/blueletter";
const CONTENT = "/content";
const BANNER = "/banner";

// common
export const uploadAndGetUrl = (): string => `${COMMON}/uploadAndGetUrl`;
export const getHompepageIndustrialTech = (): string =>
  `${COMMON}/industrialTech`;
export const uploadBusinessPlanFile = (): string =>
  `${COMMON}/businessPlanFile`;
export const uploadGoogleBusinessPlanFile = (): string =>
  `${COMMON}/googleFile`;
export const getServerTime = (): string => `${COMMON}/serverTime`;
export const downloadByKey = () => `${COMMON}/file`;
// common

// user
export const updateIndustrialTech = (): string => `${USER}/industrialTech`;
export const adminLogin = (): string => `${USER}/masterUser`;
export const checkToken = (): string => `${USER}/token`;
// user

// portfolio
export const sendApply = (): string => `${PORTFOLIO}/apply`;
export const sendPartnership = (): string => `${PORTFOLIO}/partnership`;
// portfolio

// event
export const createEvent = (): string => `${EVENT}`;
export const getEventList = (): string => `${EVENT}`;
export const updateEvent = (): string => `${EVENT}`;
export const getEventDetail = (id: string | number): string => `${EVENT}/${id}`;
export const deleteEvent = (id: string | number): string => `${EVENT}/${id}`;
// event

// blueletter
export const createBlueLetter = (): string => `${BLUE_LETTER}`;
export const getBlueLetterList = (): string => `${BLUE_LETTER}`;
export const updateBlueLetter = (): string => `${BLUE_LETTER}`;
export const deleteBlueLetter = (id: string | number): string =>
  `${BLUE_LETTER}/${id}`;
export const subscribeblueLetter = (): string => `${BLUE_LETTER}/subscribe`;
// blueletter

// Content
export const createContent = (): string => `${CONTENT}`;
export const getContentList = (): string => `${CONTENT}`;
export const updateContent = (): string => `${CONTENT}`;
export const getContentDetail = (id: string | number): string =>
  `${CONTENT}/${id}`;
export const deleteContent = (id: string | number): string =>
  `${CONTENT}/${id}`;
// Content

// Banner
export const createBanner = (): string => `${BANNER}`;
export const getBannerList = (): string => `${BANNER}`;
export const updateBanner = (): string => `${BANNER}`;
export const getBannerDetail = (id: string | number): string =>
  `${BANNER}/${id}`;
export const deleteBanner = (id: string | number): string => `${BANNER}/${id}`;
// Banner

// IR Archive
export const createIRArchives = (): string => `${IR_ARCHIVES}`;
export const deleteIRArchives = (): string => `${IR_ARCHIVES}`;
export const getIRArchives = (): string => `${IR_ARCHIVES}`;
// IR Archive

// IR Announcement
export const getIRAnnouncementUser = (): string => `${IR_ANNOUNCEMENT}/user`;
export const getIRAnnouncementAdmin = (): string => `${IR_ANNOUNCEMENT}/admin`;
export const getIRAnnouncementDetail = (id: number | string): string =>
  `${IR_ANNOUNCEMENT}/user/${id}`;
export const uploadIRAnnouncementFile = (): string => `${IR_ANNOUNCEMENT}/file`;

export const createIRAnnouncement = (): string => `${IR_ANNOUNCEMENT}`;
export const updateIRAnnouncement = (): string => `${IR_ANNOUNCEMENT}`;
export const deleteIRAnnouncement = (id: number | string): string =>
  `${IR_ANNOUNCEMENT}/${id}`;

// IR Announcement

// Popup
export const createPopup = (): string => `${POPUP}`;
export const updatePopup = (): string => `${POPUP}`;
export const getPopupListForClient = (): string => `${POPUP}/show`;
export const getPopupListForAdmin = (): string => `${POPUP}/admin`;
export const updatePopupAll = (): string => `${POPUP}/all`;
export const deletePopup = (id: string | number) => `${POPUP}/${id}`;
// Popup

// StockInfo
export const getStockInfoCurrentValue = (): string =>
  `${STOCK_INFO}/currentValue`;
export const getStockInfoDaily = (): string => `${STOCK_INFO}/daily`;
// StockInfo
